import { Navigation } from "@/components/layout/Navigation";
import { Footer } from "@/components/layout/Footer";
import { TrustpilotStrip } from "@/components/layout/TrustpilotStrip";

import { HeroSection } from "@/components/sections/HeroSection";
import { HeroMarquee } from "@/components/sections/HeroMarquee";
import { IngredientsSection } from "@/components/sections/IngredientsSection";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { ScienceSection } from "@/components/sections/ScienceSection";
import { UniversityReviewsSection } from "@/components/sections/UniversityReviewsSection";
import { ComparisonSection } from "@/components/sections/ComparisonSection";
import { VideoTestimonialsSection } from "@/components/sections/VideoTestimonialsSection";
import { ManufacturingSection } from "@/components/sections/ManufacturingSection";
import { FeaturesSection } from "@/components/sections/FeaturesSection";
import { CTASection } from "@/components/sections/CTASection";
import { FAQSection } from "@/components/sections/FAQSection";
import { PhotosMarquee } from "@/components/sections/PhotosMarquee";

// Data imports
import { testimonials } from "@/data/testimonials";
import { universityReviews } from "@/data/universityReviews";
import { videoTestimonials } from "@/data/videoTestimonials";
import { faqs } from "@/data/faqs";

/**
 * App Component
 * Main landing page application
 */
function App() {
  return (
    <div id="main-scroll-container" className="app-container scrollbar-hide">
      {/* Navigation */}
      <Navigation />

      {/* Main Content */}
      <main className="flex-1 flex flex-col">
        {/* Hero Section */}
        <HeroSection />

        {/* Press Logos Marquee */}
        <HeroMarquee />

        {/* Ingredients Section */}
        <section id="ingredients">
          <IngredientsSection />
        </section>

        {/* Testimonials Section */}
        <TestimonialsSection testimonials={testimonials} />

        {/* Science Section */}
        <ScienceSection />

        {/* University Reviews Section */}
        <section id="research">
          <UniversityReviewsSection reviews={universityReviews} />
        </section>

        {/* Comparison Section */}
        <ComparisonSection />

        {/* Video Testimonials Section */}
        <VideoTestimonialsSection videos={videoTestimonials} />

        {/* Manufacturing Section */}
        <ManufacturingSection />

        {/* Features Section */}
        <FeaturesSection />

        {/* CTA Section */}
        <CTASection />

        {/* FAQ Section */}
        <FAQSection faqs={faqs} />

        {/* Customer Photos Marquee */}
        <PhotosMarquee />
      </main>

      {/* Trustpilot Strip */}
      <TrustpilotStrip />

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
